import React from 'react';

import { MasterPageHeader } from '../PageHeader';

import { BACK_EVENT_SOURCE } from '../../utilities/constants';

/**
 * 現場掲示板 マスターヘッダー
 * @returns { JSX.Element }
 */
export function FieldBulletinBoardMasterHeader({ handleBack, title }) {
  return (
    <React.Fragment>
      <MasterPageHeader
        title={title}
        onClose={() => handleBack(BACK_EVENT_SOURCE.MASTER_PAGE_HEADER)}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardMasterHeader.jsx